import type React from "react";
import { useState } from "react";

interface CommentFormProps {
	onSubmit: (data: { authorName?: string; content: string }) => void;
	isLoading?: boolean;
	initialContent?: string;
	placeholder?: string;
	title?: string;
	className?: string;
	onCancel?: () => void;
	showCancel?: boolean;
}

export const CommentForm: React.FC<CommentFormProps> = ({
	onSubmit,
	isLoading = false,
	initialContent = "",
	placeholder = "Your thoughts...",
	title,
	className = "comment-form",
	onCancel,
	showCancel = false,
}) => {
	const [authorName, setAuthorName] = useState("");
	const [content, setContent] = useState(initialContent);

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		if (!content) return;
		// Send authorName only if provided, otherwise backend uses identity
		onSubmit({
			...(authorName ? { authorName } : {}),
			content,
		});
		setContent("");
	};

	return (
		<form className={className} onSubmit={handleSubmit}>
			{title && <h4>{title}</h4>}
			<input
				type="text"
				placeholder="Your Name (optional)"
				value={authorName}
				onChange={(e) => setAuthorName(e.target.value)}
			/>
			{!authorName && (
				<p className="comment-note">
					Leaving name blank will post as your anonymous profile.
				</p>
			)}
			<textarea
				placeholder={placeholder}
				value={content}
				onChange={(e) => setContent(e.target.value)}
				required
			/>
			<div className="form-actions">
				{showCancel && (
					<button type="button" className="cancel-btn" onClick={onCancel}>
						Cancel
					</button>
				)}
				<button type="submit" disabled={isLoading || !content}>
					{isLoading ? "Posting..." : title ? "Post Comment" : "Post"}
				</button>
			</div>
		</form>
	);
};
